import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, ViewEncapsulation, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'projects/components/pay-icon/icon.component';
import { COPYVALUE } from './copy-balloon-button.directive';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'pay-lib-copy-balloon-button',
  imports: [NgClass, TranslateModule, IconComponent],
  templateUrl: './copy-balloon-button.component.html',
  styleUrls: ['./copy-balloon.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyBalloonButtonComponent {
  private valueToCopy = inject<string>(COPYVALUE);
  private _cd = inject(ChangeDetectorRef);

  valueHasBeenCopied = false;
  public hidden = true;
  turningHidden = false;
  public destroy = new EventEmitter();

  @HostListener('click', ['$event'])
  copyValueToClipboard(event: MouseEvent) {
    event.stopPropagation();
    navigator.clipboard.writeText(this.valueToCopy).then(() => {
      this.valueHasBeenCopied = true;
      this._cd.markForCheck();
      setTimeout(() => {
        this.valueHasBeenCopied = false;
        this._cd.markForCheck();
      }, 3000);
    });
  }

  @HostListener('mouseenter')
  keepVisible() {
    this.turningHidden = false;
  }

  @HostListener('mouseleave')
  turnHidden() {
    this.hidden = true;
    this._cd.markForCheck();
    this.destroy.emit();
  }

  makeVisible() {
    this.hidden = false;
    this._cd.markForCheck();
  }

  makeHidden() {
    this.turningHidden = true;
    setTimeout(() => {
      if (this.turningHidden) {
        this.turningHidden = false;
        this.hidden = true;
        this._cd.markForCheck();
        this.destroy.emit();
      }
    }, 50);
  }
}
